export const ReadingKindle = require('./reading-kindle.png');
export const ReadingPhone = require('./reading-phone.png');

